<template>
    <table class="guide-table">
      <thead>
          <tr>
          <th :colspan="columns.length" class="logo-header">
            <img
              :src="require(`../../public/logos/${logoUrl}`)"
              class="mfg-logo"        
            />
          </th>
        </tr>
        <tr>
          <th v-for="(column, index) in columns" :key="index">{{ column }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in rows" :key="index" :class="index % 2 === 0 ? `${rowClass}` : 'odd'">
          <td v-for="(value, name, index) in row" :key="index">
            <span v-html="value"></span>
          </td>
        </tr>
      </tbody>
    </table>
</template>

<script>
export default {
  name: "StockListTable",
  props: {
    logoUrl: String,
    columns: {
        type: Array,
        default: () => [{}]
      },
    rows: {
        type: Array,
        default: () => [{}]
      },
    rowClass: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
table {
  width: 100%;
}
th {
  font-size: 20px;
  background: #fff;
}
.guide-table {
  text-align: center;
  margin-bottom: 2em;
}
.goldcreek {
    background-color: #e9b304
}

.yangs {
    background-color: #d0333b6b;
}

.bakecrafters {
    background-color: #ce20296b;
}

.tastybrands {
    background-color: #83c22f6b;
}

.wildmikes {
    background-color: #527548ec;
}
.jtm {
  background-color: #1111116b;
}
.odd {
  background-color: #fafafa;
}
.mfg-logo {
    max-width: 150px;
}



/* MOBILE */
@media screen and (max-width: 700px) {

  .logo-header {
    text-align: left;
  }

}
</style>
